import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es7.object.entries.js";
/* eslint-disable no-param-reassign */
import produce from 'immer';
var genomesLoaded = produce(function (draft, action) {
  var genomes = action.payload.genomes;
  Object.entries(genomes).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      type = _ref2[0],
      genomeList = _ref2[1];
    genomeList.forEach(function (genome) {
      draft[type][genome.id] = genome;
    });
  });
});
export default genomesLoaded;